import { render } from "./CastellAttach-Modal.vue?vue&type=template&id=b6379d40"
import script from "./CastellAttach-Modal.vue?vue&type=script&lang=js"
export * from "./CastellAttach-Modal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__